import i18n from "@/i18n";
import dayjs from "dayjs";

const TranslationsService = {
  get defaultLocale() {
    return "de";
  },

  async changeLocale(newLocale: any) {
    if (!TranslationsService.isLocaleSupported(newLocale)) {
      newLocale = TranslationsService.guessDefaultLocale();
    }

    i18n.global.locale.value = newLocale;
    dayjs.locale(newLocale);
    localStorage.setItem('culture-name', newLocale);
  },

  isLocaleSupported(locale: any) {
    return i18n.global.availableLocales.includes(locale);
  },

  getUserLocale() {
    const locale =
      window.navigator.language || TranslationsService.defaultLocale;

    return {
      locale: locale,
      localeNoRegion: locale.split("-")[0],
    };
  },

  getPersistedLocale() {
    const persistedLocale = localStorage.getItem('culture-name');

    if (TranslationsService.isLocaleSupported(persistedLocale)) {
      return persistedLocale;
    } else {
      return null;
    }
  },

  guessDefaultLocale() {
    const userPersistedLocale = TranslationsService.getPersistedLocale();
    if (userPersistedLocale) {
      return userPersistedLocale;
    }

    const userPreferredLocale = TranslationsService.getUserLocale();

    if (TranslationsService.isLocaleSupported(userPreferredLocale.locale)) {
      return userPreferredLocale.locale;
    }

    if (
      TranslationsService.isLocaleSupported(userPreferredLocale.localeNoRegion)
    ) {
      return userPreferredLocale.localeNoRegion;
    }

    return TranslationsService.defaultLocale;
  },

  async routeMiddleware(to: any) {
    const paramLocale = to.params.locale;
    await TranslationsService.changeLocale(paramLocale);
  },

  i18nRoute(to: any) {
    return {
      ...to,
      params: {
        locale: i18n.global.locale.value,
        ...to.params,
      },
    };
  },
};

export default TranslationsService;
